import React from 'react';
import { useSelector } from 'react-redux';
import ReportCard from './ReportCard';
import leadApi from '../../api/leadApi';

const LeadsReport = () => {
    const token = useSelector(state => state.auth.access_token);

    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    const endDate = today.toISOString().split('T')[0];
    const startDate = oneYearAgo.toISOString().split('T')[0];

    const reportConfigs = [
        {
            reportType: 'created-between',
            label: 'Created Between',
            fetchFunction: (token, filters) =>
                leadApi.getLeadsCreatedBetween(token, filters.startDate, filters.endDate),
            defaultFilters: { startDate, endDate }
        },
        {
            reportType: 'status-changed-to-contacted',
            label: 'Status Changed To Contacted',
            fetchFunction: (token, filters) =>
                leadApi.getStatusChangedToContacted(token, filters.startDate, filters.endDate),
            defaultFilters: { startDate, endDate }
        },
        {
            reportType: 'status-changed-to',
            label: 'Status Changed To Specific',
            fetchFunction: (token, filters) =>
                leadApi.getStatusChangedTo(token, filters.status, filters.startDate, filters.endDate),
            defaultFilters: {
                status: 'Contacted',
                startDate,
                endDate
            }
        },
        {
            reportType: 'created-by',
            label: 'Created By',
            fetchFunction: (token) => leadApi.getLeadsCreatedBy(token),
            defaultFilters: {}
        },
        {
            reportType: 'leads-by-user',
            label: 'Leads By User',
            fetchFunction: (token, filters) =>
                leadApi.getLeadsByUser(token, filters.userId, filters.startDate, filters.endDate),
            defaultFilters: {
                userId: '',
                startDate,
                endDate
            }
        },
        {
            reportType: 'created-by-range',
            label: 'Created By Range',
            fetchFunction: (token, filters) => leadApi.getLeadsCreatedByRange(token, filters.startDate, filters.endDate),
            defaultFilters: { startDate, endDate }
        },
        {
            reportType: 'status-summary',
            label: 'Status Summary',
            fetchFunction: (token) => leadApi.getStatusSummary(token),
            defaultFilters: {}
        },


    ];

    return (
        <div className="max-w-7xl mx-auto p-6 space-y-6">
            <h1 className="text-3xl font-bold text-gray-800">Leads Reports</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {reportConfigs.map((config, i) => (
                    <ReportCard key={i} {...config} token={token} />
                ))}
            </div>
        </div>
    );
};

export default LeadsReport;
